module.exports = __webpack_public_path__ + "img/mayledan_profile_picture.d8cecd04.png";